import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { useContext, useState } from 'react';
import { UsePortalSettingsAccountPassword } from './PortalSettingsAccountPassword.types';

export const usePortalSettingsAccountPassword =
  (): UsePortalSettingsAccountPassword => {
    const { t } = useI18n('portal-settings');

    const { user } = useContext(LoggedUserContext);

    const [isConfirmModalOpened, setIsConfirmModalOpened] = useState(false);

    return {
      t,
      loginType: user?.loginType,
      featureEnabled: true,
      isConfirmModalOpened,
      closeConfirmModal: () => setIsConfirmModalOpened(false),
      openConfirmModal: () => setIsConfirmModalOpened(true)
    };
  };
